import _classCallCheck from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectSpread from "/Users/nicolas/Creations/umber/umber2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import { getNativeContext } from '../helpers/get-native-context';
var DEFAULT_OPTIONS = {
  channelCount: 6,
  channelCountMode: 'explicit',
  channelInterpretation: 'discrete',
  numberOfOutputs: 6
};

var sanitizedOptions = function sanitizedOptions(options) {
  return _objectSpread({}, options, {
    channelCount: options.numberOfOutputs
  });
};

export var createChannelSplitterNodeConstructor = function createChannelSplitterNodeConstructor(createChannelSplitterNodeRenderer, createNativeChannelSplitterNode, isNativeOfflineAudioContext, noneAudioDestinationNodeConstructor) {
  return (
    /*#__PURE__*/
    function (_noneAudioDestination) {
      _inherits(ChannelSplitterNode, _noneAudioDestination);

      function ChannelSplitterNode(context) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

        _classCallCheck(this, ChannelSplitterNode);

        var nativeContext = getNativeContext(context);
        var mergedOptions = sanitizedOptions(_objectSpread({}, DEFAULT_OPTIONS, options));
        var nativeChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, mergedOptions);
        var channelSplitterNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelSplitterNodeRenderer() : null;
        return _possibleConstructorReturn(this, _getPrototypeOf(ChannelSplitterNode).call(this, context, 'passive', nativeChannelSplitterNode, channelSplitterNodeRenderer));
      }

      return ChannelSplitterNode;
    }(noneAudioDestinationNodeConstructor)
  );
};